<template>
  <div>
    <v-tabs v-model="tab" background-color="primary" fixed-tabs>
      <v-tabs-slider style="color: rgba(0, 0, 0, 0.54) !important"></v-tabs-slider>
      <v-tab href="#cliente" style="color: white !important">Cliente</v-tab>
      <v-tab href="#produtos" style="color: white !important">Produtos</v-tab>
      <v-tab href="#totais" style="color: white !important">Totais</v-tab>
    </v-tabs>

    <v-form ref="form" @submit.prevent="salvar" v-model="validateForm" lazy-validation>
      <v-tabs-items v-model="tab">

        <div class="d-flex justify-center grey lighten-4" v-if="loading">
          <v-progress-circular  size="30" width="3" style="margin-top: 15px; margin-bottom: 15px" indeterminate color="primary"></v-progress-circular>
        </div>

          <div v-else>
            <v-tab-item value="cliente" eager class="grey lighten-4">
              <v-container>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field filled dense readonly v-model="pedido.cliente.nomeRazaoSocial" name="cliente" label="Cliente" append-icon="mdi-magnify" @click:append="dialogoBuscarCliente=true" @click="dialogoBuscarCliente=true" readonly></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field filled dense readonly v-model="pedido.cliente.cpfCnpj" name="cpfcnpj" label="CPF/CNPJ"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field filled dense readonly v-model="pedido.cliente.rgIe" name="cpfcnpj" label="RG/Insc Estadual"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field filled dense readonly v-model="pedido.cliente.municipio[0].nome" name="cidade" label="Cidade"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field filled dense readonly v-model="pedido.cliente.municipio[0].microrregiao.mesorregiao.UF.nome" name="estado" label="Estado"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field filled dense readonly v-model="pedido.cliente.telefone" name="telefone" label="Telefone"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item value="produtos" eager class="fill-height grey lighten-4">
              <v-container fill-height v-if="pedido.produtos.length == 0">
                <v-row align="center" justify="center">
                  <v-col>
                    <div class="headline text-center">Adicione produdos ao pedido</div>
                  </v-col>
                </v-row>
              </v-container>

              <v-list three-line v-else class="grey lighten-4">
                <template v-for="(produto, index) in pedido.produtos">
                  <v-list-item :key="index" @click="abrirValorEdit(produto)">
                    <v-list-item-icon color="primary">
                      #{{index+1}}
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{ produto.codigo }} </v-list-item-subtitle>
                      <v-list-item-title>{{ produto.descricao }}</v-list-item-title>
                      <v-list-item-subtitle>{{ produto.quantidade | valorBR }} x {{ produto.valor | valorBR }} = <b>{{ produto.subtotal | valorBR }}</b></v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-icon>
                      <v-icon @click.stop="removerProduto(index)">mdi-delete</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                  <v-divider :key="index+1*10000" v-if="index < pedido.produtos.length - 1"></v-divider>
                </template>
              </v-list>
            </v-tab-item>

            <v-tab-item value="totais" class="grey lighten-4">
              <v-list class="grey lighten-4">
                <v-list-item>
                  <v-list-item-subtitle>Data</v-list-item-subtitle>
                  <v-list-item-title class="text-right">{{ pedido.data | dataBR }}</v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-subtitle>Quantidade</v-list-item-subtitle>
                  <v-list-item-title class="text-right">{{ quantidadeGeral  | valorBR}}</v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-subtitle>Valor Bruto</v-list-item-subtitle>
                  <v-list-item-title class="text-right">{{ valorGeral | valorBR }}</v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-subtitle><b>Valor Líquido</b></v-list-item-subtitle>
                  <v-list-item-title class="text-right"><b>{{ pedido.valor_liquido | valorBR }}</b></v-list-item-title>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-form ref="form_totais" v-model="form_totais">
                <v-row dense>
                  <v-col cols="12">
                    <v-select :items="vendedores" label="Vendedor" v-model="pedido.vendedor" filled dense hide-details :rules="rulesForm.vendedor"></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select :items="formas_pagamento" label="Forma de Pagamento" v-model="pedido.forma_pagamento" filled dense hide-details :rules="rulesForm.forma_pagamento"></v-select>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="6">
                    <as-campo-valor label="Desconto %" ref="desconto_percentual" v-model="pedido.desconto_percentual" filled type="number" min=0 dense hide-details @keyup.native="calcularDescontoValor" :rules="rulesForm.valor_zerado"></as-campo-valor>
                  </v-col>
                  <v-col cols="6">
                    <as-campo-valor label="Desconto R$" ref="desconto_valor" v-model="pedido.desconto_valor" filled type="number" min=0 dense hide-details @keyup.native="calcularDescontoPercentual" :rules="rulesForm.valor_zerado"></as-campo-valor>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="6">
                    <as-campo-valor label="Taxa %" ref="taxa_percentual" v-model="pedido.taxa_percentual" filled type="number" min=0 dense hide-details @keyup.native="calcularTaxaValor" :rules="rulesForm.valor_zerado"></as-campo-valor>
                  </v-col>
                  <v-col cols="6">
                    <as-campo-valor label="Taxa R$" ref="taxa_valor" v-model="pedido.taxa_valor" filled type="number" min=0 dense hide-details @keyup.native="calcularTaxaPercentual" :rules="rulesForm.valor_zerado"></as-campo-valor>
                  </v-col>
                </v-row>
              </v-form>
              <v-divider class="ma-3"></v-divider>
              <v-row dense>
                <v-col cols="12">
                  <v-btn block color="primary" @click="salvar" :disabled="salvando || !botaoSalvar" :loading="salvando">Finalizar Pedido</v-btn>
                </v-col>
              </v-row>
            </v-tab-item>
          </div>
      </v-tabs-items>
    </v-form>

    <v-fab-transition>
      <v-btn color="primary" dark fixed bottom right fab v-show="tab == 'produtos'" @click="dialogoBuscarProduto=true">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog v-model="dialogoBuscarCliente" ref="dialogoBuscarCliente" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
      <v-card>
        <v-toolbar dark color="primary" style="flex: 0 1 auto;">
          <v-btn icon dark @click="dialogoBuscarCliente=false" class="mr-4">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-text-field v-model="pesquisa_cliente" dense solo-inverted flat hide-details label="Pesquisar Cliente" ref="busca" clearable color="primary"
            @click:clear="pesquisa_cliente=''"
            @keypress.enter="buscarCliente"
            append-icon="mdi-magnify"
            @click:append="buscarCliente"
          >
          </v-text-field>
        </v-toolbar>

        <v-card-text class="pa-0">
          <v-list v-show="!loading" three-line>
            <v-subheader v-if="clientes.length > 0">Clientes</v-subheader>
            <v-subheader v-else>Faça uma busca em branco para carregar todos os clientes</v-subheader>
            
            <template v-for="(cliente, index) in clientes">
              <v-list-item :key="cliente._id" @click="selecionarCliente(cliente)">
                <v-list-item-content>
                  <v-list-item-title>{{ cliente.nomeRazaoSocial }}</v-list-item-title>
                  <v-list-item-subtitle>CPF/CNPJ: {{cliente.cpfCnpj}}</v-list-item-subtitle>
                  <v-list-item-subtitle>Local: {{cliente.municipio[0].nome}} / {{cliente.municipio[0].microrregiao.mesorregiao.UF.sigla}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="index*10000" v-if="index < clientes.length - 1"></v-divider>
            </template>
            
          </v-list>

          <v-layout row justify-center>
            <v-flex xs12 class="text-center">
              <v-progress-circular
                v-show="loading"
                style="margin-top: 150px; margin-bottom: 15px"
                indeterminate
                color="black"
                ></v-progress-circular>
            </v-flex>
          </v-layout>
          <br>
          
          <h2 v-show="!loading && (clientes.length == 0)" class="text-center">Nenhum resultado!</h2>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoBuscarProduto" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
      <v-card>
        <v-toolbar dark color="primary" style="flex: 0 1 auto;">
          <v-btn icon dark @click="dialogoBuscarProduto=false" class="mr-4">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-text-field v-model="pesquisa_produto" dense solo-inverted flat hide-details label="Pesquisar Produtos" ref="busca" clearable color="primary" 
            @click:clear="pesquisa_produto=''"
            @keypress.enter="buscarProduto"
            append-icon="mdi-magnify"
            @click:append="buscarProduto"
            >
          </v-text-field>
        </v-toolbar>

        <v-card-text class="pa-0">
          <v-list v-show="!loading" three-line>
            <v-subheader v-if="produtos.length > 0">Produtos</v-subheader>
            <v-subheader v-else>Faça uma busca em branco para carregar todos os produtos</v-subheader>

            <template v-for="(produto, index) in produtos">
              <v-list-item :key="produto._id" @click="selecionarProduto(produto)">
                <v-list-item-content>
                  <v-list-item-title v-html="produto.descricao"></v-list-item-title>
                  <v-list-item-subtitle>
                    Referência: {{produto.codigo}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>Estoque: {{ produto.estoque}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text><b>R$ {{ produto.valor }}</b></v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="index*10000" v-if="index < produtos.length - 1"></v-divider>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoQuantidadeProduto" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
      <v-card>
        <v-toolbar dark color="primary" style="flex: 0 1 auto;">
          <v-btn icon dark @click="dialogoQuantidadeProduto=false" class="mr-4">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title>Quantidade Produto</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-4 pt-0">
          <v-subheader style="margin-left: 0px">Informe a quantidade desse produto</v-subheader>
          <v-row>
            <v-col cols="12" class="text--primary">
              <h2>{{produto.codigo}} - {{produto.descricao}}</h2>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <as-campo-valor label="Valor R$" ref="valor_produto" v-model="produto.valor" filled type="number" @input="calcularSubtotalProduto" min=0></as-campo-valor>
            </v-col>
            <v-col cols="12">
              <as-campo-valor label="Quantidade" ref="quantidade_produto" v-model="produto.quantidade" filled type="number" @input="calcularSubtotalProduto" min=0></as-campo-valor>
            </v-col>
            <v-col cols="12">
              <as-campo-valor label="SubTotal" ref="subtotal_produto" v-model="produto.subtotal" filled type="number" readonly></as-campo-valor>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-row>
            <v-col cols="6">
              <v-btn block color="grey lighten-2" @click="dialogoQuantidadeProduto=false">Cancelar</v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn block color="primary" :disabled="!produtoValido" @click="salvarProduto">Confirmar</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoRemoverProduto" scrollable persistent :overlay="false" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>
          Remover Produto?
        </v-card-title>

        <v-card-text>
          <slot>O produto selecionado será removido do pedido</slot>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelarRemocaoProduto">Cancelar</v-btn>
          <v-btn text color="primary" @click="confirmarRemocao">Remover</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../api/index.js";

export default {
  name: 'PedidosForm',
  data () {
    return {
      loading: false,
      salvando: false,
      form_totais: true,
      tab: 'cliente',
      validateForm: true,
      rulesForm: {
        cliente: [ value => !!value || 'Obrigatório' ],
        vendedor: [ value => !!value || 'Obrigatório' ],
        forma_pagamento: [ value => !!value || 'Obrigatório' ],
        valor_zerado: [
          (value) =>
            parseFloat(value.replace(",", ".")) >= 0 ||
            "O valor não pode ser negativo",
        ],
      },
      dialogoBuscarCliente: false,
      pesquisa_cliente: '',
      clientes: [],
      dialogoBuscarProduto: false,
      pesquisa_produto: '',
      produtos: [],
      produto: {
        _id: '',
        codigo: '',
        descricao: '',
        quantidade: 0,
        subtotal: 0,
      },
      dialogoQuantidadeProduto: false,
      produto_index: null,
      dialogoRemoverProduto: false,
      formas_pagamento: ['À Vista', 'Cartão de Crédito', 'Cartão de Débito'],
      vendedores: ['João', 'Maria', 'Luís', 'Marcos'],
    }
  },
  mounted () {
    if (this.pedido_props) {
      this.pedido = this.pedido_props;
    } else {
      this.pedido.data = new Date().toJSON().slice(0,10);
    }
  },
  methods: {
    buscarCliente () {
      this.loading = true;
      if (this.pesquisa_cliente) {
        api.buscarCliente(this.pesquisa_cliente, 
          data => {
            this.clientes = data;
            this.loading = false;
          },
          error => {
            this.loading = false;
          }
        );
      } else {
        api.getClientes(
          data => {
            this.clientes = data;
            this.loading = false;
          },
          error => {
            this.loading = false;
          }
        );
      }
    },
    selecionarCliente (cliente_selecionado) {
      this.pedido.cliente = JSON.parse((JSON.stringify(cliente_selecionado)));
      this.dialogoBuscarCliente= false;
    },
    buscarProduto () {
      this.loading = true;
      if (this.pesquisa_produto) {
        api.buscarProduto(this.pesquisa_produto, 
          data => {
            this.produtos = data;
            this.loading = false;
          },
          error => {
            this.loading = false;
          }
        );
      } else {
        api.getProdutos(
          data => {
            this.loading = false;
            this.produtos = data;
          },
          error => {
            this.loading = false;
          }
        );
      }
    },
    selecionarProduto(produto_selecionado) {
      this.produto = JSON.parse((JSON.stringify(produto_selecionado)));
      this.dialogoQuantidadeProduto = true;
      this.dialogoBuscarProduto= false;
    },
    calcularSubtotalProduto () {
      this.produto.subtotal = this.produto.quantidade * this.produto.valor;
    },
    salvarProduto () {
      this.pedido.produtos.push(this.produto);
      this.pedido.quantidade + this.quantidadeGeral;
      this.pedido.valor_bruto = this.valorGeral;
      this.calcularValorLiquido();
      this.calcularDescontoValor();
      this.calcularTaxaValor();

      this.produto = {
        _id: '',
        codigo: '',
        descricao: '',
        quantidade: 0,
        subtotal: 0,
      };
      this.pedido.valor_bruto = this.valorGeral;
      this.dialogoQuantidadeProduto = false;
      this.tab = 'produtos';
    },
    removerProduto (index) {
      this.produto_index = index;
      this.dialogoRemoverProduto = true;
    },
    confirmarRemocao() {
      this.pedido.produtos.splice(this.produto_index, 1);
      this.pedido.quantidade = this.quantidadeGeral;
      this.pedido.valor_bruto = this.valorGeral;
      this.calcularDescontoValor();
      this.calcularTaxaValor();
      this.calcularValorLiquido();
      this.dialogoRemoverProduto = false;
    },
    cancelarRemocaoProduto () {
      this.dialogoRemoverProduto=false;
      this.produto_index = null;
    },
    calcularValorLiquido() {
      this.pedido.valor_liquido = this.pedido.valor_bruto - this.pedido.desconto_valor + this.pedido.taxa_valor;
    },
    calcularDescontoValor() {
      if (this.pedido.desconto_percentual) {
        this.pedido.desconto_valor = (this.valorGeral * this.pedido.desconto_percentual) / 100;
      } else {
        this.pedido.desconto_valor = 0;
        this.pedido.desconto_percentual = 0;
      }
      this.calcularValorLiquido();
    },
    calcularDescontoPercentual() {
      if (this.pedido.desconto_valor) {
        this.pedido.desconto_percentual = (this.pedido.desconto_valor / this.valorGeral) * 100;
      } else {
        this.pedido.desconto_percentual = 0;
        this.pedido.desconto_valor = 0;
      }
      this.calcularValorLiquido();
    },
    calcularTaxaValor() {
      if (this.pedido.taxa_percentual) {
        this.pedido.taxa_valor = (this.valorGeral * this.pedido.taxa_percentual) / 100;
      } else {
        this.pedido.taxa_valor = 0;
        this.pedido.taxa_percentual = 0;
      }
      this.calcularValorLiquido();
    },
    calcularTaxaPercentual() {
      if (this.pedido.taxa_valor) {
        this.pedido.taxa_percentual = (this.pedido.taxa_valor / this.valorGeral) * 100;
      } else {
        this.pedido.taxa_percentual = 0;
        this.pedido.taxa_valor = 0;
      }
      this.calcularValorLiquido();
    },
    salvar() {
      this.salvando = true;
      if (this.pedido._id) {
        api.patchPedido(this.pedido, data => {
          console.log(data);
          this.$router.push('/pedidos');
        });
      } else {
        api.postPedido(this.pedido, data => {
          console.log(data);
          this.$router.push('/pedidos');
        });
      }
    }
  },
  computed: {
    pedido(){
      return this.$store.state.pedido;
    },
    produtoValido () {
      if (this.produto.quantidade > 0 && this.produto.valor > 0 && this.produto.subtotal > 0) {
        return true;
      } else {
        return false;
      }
    },
    quantidadeGeral() {
      let qtd_total = 0;

      qtd_total = this.pedido.produtos.reduce((soma, produto) => {
        return soma + produto.quantidade;
      }, 0);

      return qtd_total;
    },
    valorGeral() {
      let valor_total = 0;

      valor_total = this.pedido.produtos.reduce((soma, produto) => {
        return soma + produto.subtotal;
      }, 0);

      return valor_total;
    },
    botaoSalvar () {
      if (this.pedido.produtos.length > 0
        && this.form_totais
        && this.pedido.cliente.cpfCnpj
        && this.pedido.valor_liquido > 0
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>

<style></style>